"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.assetRedemptionRequirementToUser = exports.assetRedemptionToUser = exports.AssetRedemptionStatus = void 0;
const asset_rewards_1 = require("./asset-rewards");
/**
 * Internal
 */
var AssetRedemptionStatus;
(function (AssetRedemptionStatus) {
    AssetRedemptionStatus["InProgress"] = "IN_PROGRESS";
    AssetRedemptionStatus["Qualified"] = "QUALIFIED";
    AssetRedemptionStatus["Redeemed"] = "REDEEMED";
    AssetRedemptionStatus["Paid"] = "PAID";
    AssetRedemptionStatus["Expired"] = "EXPIRED";
})(AssetRedemptionStatus = exports.AssetRedemptionStatus || (exports.AssetRedemptionStatus = {}));
// Map a full asset redemption entity to a user asset redemption
function assetRedemptionToUser(assetRedemption) {
    const { assetReward, requirements, ...rest } = assetRedemption;
    return {
        ...rest,
        assetReward: assetReward ? (0, asset_rewards_1.assetRewardToUser)(assetReward) : undefined,
        requirements: requirements?.map(assetRedemptionRequirementToUser),
    };
}
exports.assetRedemptionToUser = assetRedemptionToUser;
// Map a full asset redemption requirement entity to a user asset redemption requirement
function assetRedemptionRequirementToUser(requirement) {
    return {
        trigger: requirement.trigger,
        thresholdAssetId: requirement.thresholdAssetId,
        thresholdAmount: requirement.thresholdAmount,
        progress: requirement.progress,
    };
}
exports.assetRedemptionRequirementToUser = assetRedemptionRequirementToUser;
//# sourceMappingURL=asset-redemptions.js.map